import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'
import DateTime from 'react-datetime'


const renderStatusList = (list) => {
  return (
    Object.keys(list).map(item => {
      return (<option key={item} value={item}>{list[item]}</option>);
    })
  );
};

const OrdersSearch = (props) => {
        return (
          <Panel className="order-filter">
            <Row>
              <Col md={4}>
                <FormGroup>
                  <FormControl onChange={props.onInputChange}
                               placeholder="Enter order number"
                               value={props.searchValue}/>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <DateTime timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            value={props.dateFromValue}
                            onChange={props.onDateFromChange}
                            closeOnSelect
                            inputProps={{
                              placeholder: 'Date from'
                            }}/>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <DateTime timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            value={props.dateToValue}
                            onChange={props.onDateToChange}
                            closeOnSelect
                            inputProps={{
                              placeholder: 'Date to'
                            }}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <FormControl value={props.statusOrderValue}
                               onChange={props.onStatusOrderChange}
                               componentClass="select">
                    <option value="">[Status]</option>
                    { renderStatusList(props.statusList) }
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={6} className="actions">
                <Button className="red-ghost-btn"
                        onClick={props.onSearch}>Search</Button>

                <Button className="red-ghost-btn"
                        onClick={props.onClear}>Clear search/filters</Button>
              </Col>
            </Row>
          </Panel>
        );
};

export default OrdersSearch;


// WEBPACK FOOTER //
// ./src/components/admin/orders/orders-search.jsx